import React, { useEffect, useState } from "react";
import API from "../api";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./AdminDashboard.css";

export default function EmployeeProfile() {
    const [employees, setEmployees] = useState([]);
    const [search, setSearch] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [page, setPage] = useState(1);
    const limit = 10;
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    // -------------------------
    // LOAD EMPLOYEES
    // -------------------------
    const loadEmployees = async () => {
        try {
            const res = await API.get("/profile");
            setEmployees(res.data);
        } catch (err) {
            console.error("Failed to load employees", err);
        }
    };

    useEffect(() => {
        loadEmployees();
    }, []);

    // -------------------------
    // FILTER BY SEARCH
    // -------------------------
    const filteredEmployees = employees.filter((emp) =>
        emp.name?.toLowerCase().includes(search.toLowerCase())
    );
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;

    const paginatedEmployees = filteredEmployees.slice(startIndex, endIndex);

    return (
        <div className="dashboard-wrapper">
            {/* Sidebar */}
            <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
                <Sidebar />
            </div>

            <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
                <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

                <div className="main-content">
                    <div className="container-fluid py-4">
                        <div className="dashboard-title">
                            <img
                                src="/Dashboard-Red-64.png"
                                alt="dashboard"
                                className="dashboard-icon"
                            />
                            <span>Dashboard</span>
                        </div>

                        {/* HEADER */}
                        <div className="search-card">
                            <h2>Employee Profiles</h2>



                            <div style={{ position: "relative" }}>
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Search Employee..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <span style={{
                                    position: "absolute",
                                    right: 18,
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                }}>🔍</span>
                            </div>

                        </div>

                        {/* TABLE */}
                        <div className="table-responsive">
                            <table className="project-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Profile</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>State</th>
                                        <th>District</th>
                                        <th>Taluka</th>
                                        {/* <th>Pincode</th>
                      <th>Address</th> */}
                                        {/* <th>Created At</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginatedEmployees.length === 0 ? (
                                        <tr>
                                            <td colSpan="11" style={{ textAlign: "center" }}>
                                                No Employees Found
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedEmployees.map((emp, index) => (
                                            <tr key={emp.id}>
                                                <td>{startIndex + index + 1}</td>


                                                <td>
                                                    {emp.profile_image ? (
                                                        <img
                                                            src={`http://163.227.92.37:7888/uploads/profile/${emp.profile_image}`}
                                                            alt="profile"
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: "50%",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                window.open(
                                                                    `http://163.227.92.37:7888/uploads/profile/${emp.profile_image}`,
                                                                    "_blank"
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>

                                                {/* <td>{emp.name}</td> */}
                                                <td>
                                                    <a
                                                        href={`/employee-profile/${emp.id}`}
                                                        style={{ color: "#007bff" }}
                                                    >
                                                        {emp.name}
                                                    </a>
                                                </td>

                                                <td>{emp.email || "-"}</td>
                                                <td>{emp.phone_number || "-"}</td>
                                                <td>{emp.state || "-"}</td>
                                                <td>{emp.district || "-"}</td>
                                                <td>{emp.taluka || "-"}</td>
                                                {/* <td>{emp.pincode || "-"}</td>
                          <td>{emp.address || "-"}</td> */}
                                                {/* <td>
                                                    {emp.created_at
                                                        ? new Date(emp.created_at).toLocaleDateString("en-GB")
                                                        : "-"}
                                                </td> */}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* PAGINATION */}
                        <div className="pagination-section">
                            <p>
                                Showing {filteredEmployees.length > 0 ? startIndex + 1 : 0} –
                                {Math.min(endIndex, filteredEmployees.length)} of {filteredEmployees.length}

                            </p>

                            <div className="pagination-controls">
                                <button disabled={page === 1} onClick={() => setPage(1)}>«</button>
                                <button disabled={page === 1} onClick={() => setPage(page - 1)}>‹</button>
                                <button className="active">{page}</button>
                                <button
                                    disabled={endIndex >= filteredEmployees.length}
                                    onClick={() => setPage(page + 1)}
                                >
                                    ›
                                </button>

                                <button disabled={endIndex >= employees.length} onClick={() => setPage(Math.ceil(employees.length / limit))}>»</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
